<agr-dialog [data]="data" (cancel)="cancel()" class="return-product-search-dialog" data-test="return-product-search-dialog">
  <div>
    <p class="spacing--margin-half-vertical">
      {{ 'product.return-search.description' | translate }}
    </p>
    <div class="flex">
      <div class="spacing--margin-right">
        <p class="spacing--margin-none-vertical text--label">
          {{ 'product.return-search.period' | translate }}
        </p>
        <p class="spacing--margin-none-vertical">
          {{ dateRange.start | agrDate }}
          {{ 'product.return-search.daterange-separator' | translate }}
          {{ dateRange.end | agrDate }}
        </p>
      </div>
      <div>
        <p class="spacing--margin-none-vertical text--label">
          {{ 'product.return-search.product-count' | translate }}
        </p>
        <p class="spacing--margin-none-vertical">
          {{ productCount | async }}
        </p>
      </div>
    </div>
  </div>
  <div class="return_product-search-dialog__form spacing--margin-top">
    <mat-form-field appearance="fill" class="return-product-search-dialog__input" data-test="return-product-search-dialog__input">
      <mat-label>{{ 'product.return-search.search-label' | translate }}</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input
        #searchBar
        type="text"
        matInput
        [placeholder]="'product.return-search.select' | translate"
        [formControl]="searchBarControl"
        (keydown.enter)="$event.preventDefault()"
        autocomplete="on"
      />
      <button *ngIf="searchBarControl.value" matSuffix mat-icon-button (click)="clearSearchBar()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="return-product-search-dialog__table spacing--margin-bottom">
    <agr-table-v2 [dataSource]="dataSource">
      <!-- Templates below are empty on purpose -->
      <ng-container *agrTableFiltersWrapper></ng-container>
      <ng-container *agrTableTopBar></ng-container>

      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'product.return-search.table.product' | translate }}
        </th>
        <td mat-cell [attr.aria-label]="'product.return-search.table.product' | translate" *matCellDef="let row">
          <div class="flex--column flex--justify-center" [class]="'return-product-search-dialog__multi-line-column'">
            <span class="text--default">{{ row.skuDetails.title }}</span>
            <span class="text--label">
              {{ 'product.search.table.article-number' | translate: { articleNumber: row.skuDetails.externalId } }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'product.return-search.table.quantity' | translate }}
        </th>
        <td mat-cell [attr.aria-label]="'product.return-search.table.quantity' | translate" *matCellDef="let row; let i = index">
          <div *ngIf="quantityForms as formGroup" class="column-quantity">
            <ng-container>
              <mat-form-field
                floatLabel="auto"
                subscriptSizing="dynamic"
                appearance="fill"
                (click)="$event.stopPropagation()"
                class="full-width-field spacing--padding-right mat-form-field__no-spacing column-quantity__form-field"
              >
                <mat-label>{{ 'app.favorites.quantity' | translate }}</mat-label>
                <input matInput agrNumber [step]="1" [min]="1" [max]="1000" [formControl]="$any(formGroup.at(i))" />
                <span *ngIf="row.skuDetails.unit" matIconSuffix data-test="table-desktop__input-number-suffix" [attr.data-translate-key]="row.skuDetails.unit">
                  {{ 'unit.' + row.skuDetails.unit | translate }}
                </span>
              </mat-form-field>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="invoice">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'product.return-search.table.invoice' | translate }}
        </th>
        <td mat-cell [attr.aria-label]="'product.return-search.table.invoice' | translate" *matCellDef="let row">
          <div class="flex--column flex--justify-center" [class]="'return-product-search-dialog__multi-line-column'">
            <span class="text--default">{{ row.externalInvoiceId }}</span>
            <span class="text--label">
              {{ row.invoiceDate | agrDate: 'shortDate' }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="addToCart">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row; let i = index">
          <div class="flex--row flex--align-end flex--justify-center return-product-search-dialog__add-to-cart-wrapper">
            <ng-container *ngIf="quantityForms.at(i) as quantityFormControl">
              <button
                mat-flat-button
                color="primary"
                class="text--small return-product-search-dialog__add-to-cart"
                data-test="return-product-search-dialog__add-to-cart"
                (click)="addReturnLineToCart(row, i)"
                [disabled]="doesCartContainItem(row, disabledSkus$ | async) || quantityFormControl.invalid"
              >
                <mat-icon class="return-product-search-dialog__add-shopping-icon">add_shopping_cart</mat-icon>
                <span *ngIf="doesCartContainItem(row, disabledSkus$ | async)">
                  {{ 'product.return-search.table.already-in-cart' | translate }}
                </span>
                <span *ngIf="!doesCartContainItem(row, disabledSkus$ | async)">
                  {{ 'product.return-search.table.add-to-cart' | translate }}
                </span>
              </button>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let myRowData; columns: tableColumns"></tr>
      <tr *matNoDataRow>
        <td class="text--center" [attr.colspan]="tableColumns.length">
          <agr-notification-empty
            data-test="return-table-data__empty"
            [isEmpty]="true"
            [emptyTitle]="'product.return-search.table.empty-title' | translate"
            [emptyDescription]=""
            [emptyImage]="'/assets/images/no-items-3.png'"
            class="spacing--margin-top"
          ></agr-notification-empty>
        </td>
      </tr>
    </agr-table-v2>
  </div>
</agr-dialog>
